import { render, staticRenderFns } from "./ItemStatsWidget.vue?vue&type=template&id=2b00ff6a"
import script from "./ItemStatsWidget.vue?vue&type=script&lang=js"
export * from "./ItemStatsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports